import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { SessionByRoomKey } from "@classview/shared-types";
import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from "@tanstack/react-query";

const getSessionByKey = async (key: string): Promise<SessionByRoomKey> => {
  const response = await axiosClient.get(`sessions/room/${key}`);
  return response.data;
};

export function getSessionByKeyQueryKey({ key }: { key: string }) {
  return ["public-session", key];
}

export function useGetSessionByKey(
  key: string,
  queryOptions?: Partial<UseQueryOptions<SessionByRoomKey, HttpError>>,
): UseQueryResult<SessionByRoomKey, HttpError> {
  return useQuery({
    queryKey: getSessionByKeyQueryKey({ key }),
    queryFn: () => getSessionByKey(key),
    ...queryOptions,
  });
}
